import { IStateParamsService } from 'angular-ui-router';
import { IEcranDetailsResourcesEntite } from '../../../../../core/resources/ecran-details.resource';
import { IFormulaireItemClass } from '../../../../../core/services/formulaire/formulaire-item.service';
import { IFormulaireClass } from '../../../../../core/services/formulaire/formulaire.service';
import { IMonoOccurrenceOptions } from '../../../../../core/services/mono-occurrence.service';
import { IMultiOccurrenceOptions } from '../../../../../core/services/multi-occurrence.service';

interface IPagePB0019 {
    monoOccurrenceOptions: IMonoOccurrenceOptions;
    tepMultiOccurrenceOptions: IMultiOccurrenceOptions;
    valeursEcran: any;
}
/* @ngInject */
export default function Pb0019Controller(ecranDetails: IEcranDetailsResourcesEntite,
    Formulaire: IFormulaireClass,
    FormulaireItem: IFormulaireItemClass,
    $stateParams: IStateParamsService
) {
    const vm: IPagePB0019 = this;
    // Valeurs ecran 
    vm.valeursEcran = ecranDetails.valeurs;
    vm.monoOccurrenceOptions = {
        noId: true
    };
    // Technique Plaquette 
    vm.tepMultiOccurrenceOptions = {
        colonnesVisibles: [
            { nom: 'tepdatdeb', largeur: 140 },
            { nom: 'vaesystecsal_desc', largeur: 200 },
            { nom: 'vaetepapp', largeur: 200 }
        ],
        formulaire: new Formulaire([
            new FormulaireItem('tepdatdeb', { largeur: 33 }),
            new FormulaireItem('vaesystecsal', { largeur: 33 }),
            new FormulaireItem('vaetepapp', { largeur: 33 }),
            new FormulaireItem('poscleint', {
                default: $stateParams.poscleint,
                hidden: true
            }),
        ])
    };
}
